document.addEventListener("DOMContentLoaded", () => {
    (() => { // Cookies lišta
        const cookieConsent = document.querySelector('[data-cookie-consent]');
        if (typeof(cookieConsent) === 'undefined' || cookieConsent === null)
            return;

        setTimeout(() => {
            cookieConsent.classList.remove('is-hidden');
        }, 400);

        const form = cookieConsent.querySelector('form'),
            request = new XMLHttpRequest();

        form && form.querySelectorAll('button').forEach(btn => {
            btn.addEventListener('click', () => {
                form.submitterBtn = btn.name;
            });
        });

        form && form.addEventListener("submit", e => {
            e.preventDefault();
            const formData = new FormData(form);
            const submitterButtonName = e.submitter ? e.submitter.name : form.submitterBtn;
            formData.append('submit', submitterButtonName);

            if (submitterButtonName === 'cookies_allow' || formData.get('analytics') === 'on') {
                document.dispatchEvent(new CustomEvent('CookiesAnalyticsAcceptance'));
            }
            if (submitterButtonName === 'cookies_allow' || formData.get('marketing') === 'on') {
                document.dispatchEvent(new CustomEvent('CookiesMarketingAcceptance'));
            }

            if (submitterButtonName === 'cookies_necessary' || formData.get('analytics') === 'off' || (submitterButtonName === 'cookies_save' && formData.get('analytics') === null)) {
                document.dispatchEvent(new CustomEvent('CookiesAnalyticsDecline'));
            }
            if (submitterButtonName === 'cookies_necessary' || formData.get('marketing') === 'off' || (submitterButtonName === 'cookies_save' && formData.get('marketing') === null)) {
                document.dispatchEvent(new CustomEvent('CookiesAnalyticsDecline'));
            }

            request.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200)
                    cookieConsent.classList.add('is-hidden');
            }

            let url = "/poskireal/cookies.php";
            if (formData.get('urlRel')) {
                url = formData.get('urlRel');
            }

            request.open("POST", url, true);
            request.send(formData);
        });

        const settingsToggle = cookieConsent.querySelector('[data-cookie-consent-settings-toggle]'),
            cookieConsentSettings = cookieConsent.querySelector('[data-cookie-consent-settings]'),
            textVariant = cookieConsent.querySelectorAll('[data-cookie-consent-text-variant]');

        settingsToggle && settingsToggle.addEventListener("click", e => {
            e.preventDefault();

            cookieConsent.classList.toggle('CookieConsent--simple');

            if (typeof animJs !== "undefined")
                cookieConsentSettings && animJs.fadeToggle(cookieConsentSettings);
            else if (cookieConsentSettings)
                cookieConsentSettings.style.display = cookieConsent.classList.contains('CookieConsent--simple') ? 'none' : 'block';

            settingsToggle.classList.toggle('is-toggled');
            textVariant.forEach(field => {
                field.toggleAttribute('hidden');
            });
        });
    })();
});